import { render } from "./StepEducation.vue?vue&type=template&id=6902050a"
import script from "./StepEducation.vue?vue&type=script&lang=js"
export * from "./StepEducation.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__